<div class="page">
  <mat-card class="toolbar-card">
    <div class="toolbar-grid">
      <app-warehouse-selector [control]="warehouseControl"></app-warehouse-selector>

      <mat-form-field appearance="outline">
        <mat-label>Новая ячейка</mat-label>
        <input matInput [formControl]="codeControl" placeholder="A-01-02-03" />
      </mat-form-field>

      <button mat-flat-button color="primary" type="button" (click)="createCell()">
        Создать
      </button>

      <mat-form-field appearance="outline">
        <mat-label>Поиск</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          placeholder="Код ячейки"
          (keyup.enter)="loadCells()"
        />
      </mat-form-field>

      <button mat-stroked-button color="primary" type="button" (click)="loadCells()">
        Обновить
      </button>
    </div>
  </mat-card>

  <mat-card>
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <table mat-table [dataSource]="cells" class="cell-table">
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>Код</th>
        <td mat-cell *matCellDef="let row">{{ row.code }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Тип</th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Статус</th>
        <td mat-cell *matCellDef="let row">{{ row.isActive ? 'Активна' : 'Архив' }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="toggleActive(row)"
            [disabled]="row.type !== 'REAL'"
          >
            {{ row.isActive ? 'Архивировать' : 'Вернуть' }}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card>
</div>
